import React from "react";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";
import { ProjectElementType } from "@planzone/dto";

import { SecureContextualMenu } from "@common/secureContextualMenu";
import { useModal } from "@root/client/modal";
import { Props } from "./types";
import styles from "./styles.scss";
import { clip } from "@common/clipeable";

function Timestamp({ event }: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();

  return (
    <div className={styles.timestamp}>
      <div className={styles.contextualMenu}>
        <SecureContextualMenu
          context={{ event }}
          items={[
            {
              name: t("retrieveEvent.copyUrl"),
              useCase: UseCases.retrieveEvent,
              act: () => clip(`${location.origin}/events/${event.uuid}`, null),
            },
            {
              name: t("retrieveEvent.move"),
              useCase: UseCases.moveListElement,
              act: () =>
                pushView({
                  key: UseCases.moveListElement,
                  data: {
                    projectElementId: event.uuid,
                    projectElementType: ProjectElementType.EVENT,
                    currentParentList: event.list,
                    project: event.project,
                  },
                }),
            },
            {
              name: t("retrieveEvent.remove"),
              useCase: UseCases.removeEvent,
              color: "#DB5F63FF",
              act: () => pushView({ key: UseCases.removeEvent, data: event }),
            },
          ]}
        />
      </div>
    </div>
  );
}

export { Timestamp };
